import XLSX from 'sheetjs-style';
import moment from 'moment';

const getTypeLabel = (type) => {
  switch (type) {
    case 'shift-change':
      return 'Shift Change';
    case 'shift-swap':
      return 'Shift Swap';
    case 'day-off-change':
    case 'day-off':
      return 'Day Off';
    default:
      return type || '-';
  }
};

const getStatusLabel = (status) => {
  switch (status) {
    case 'approve':
      return 'Approved';
    case 'reject':
      return 'Rejected';
    case 'pending':
      return 'Pending';
    default:
      return status || '-';
  }
};

const ScheduleChangeRequestsExcel = (requests) => {
  const wb = XLSX.utils.book_new();

  const subHeading = [
    'Team Member',
    'Requested Date',
    'Type',
    'Status',
    'Original Schedule Start',
    'Original Schedule End',
    'New Schedule Start',
    'New Schedule End',
    'Swap With',
    'Reason',
  ];

  const excelRows = requests.map((req) => ({
    teamMember: req.teamMember || '-',
    requestedDate: req.dateRequested
      ? moment(req.dateRequested).format('MMM Do, YYYY h:mm A')
      : '-',
    type: getTypeLabel(req.type),
    status: getStatusLabel(req.status),
    originalScheduleStart: req.originalSchedule?.shiftStart
      ? moment(req.originalSchedule.shiftStart).format('MMM Do, YYYY hh:mm A')
      : '-',
    originalScheduleEnd: req.originalSchedule?.shiftEnd
      ? moment(req.originalSchedule.shiftEnd).format('MMM Do, YYYY hh:mm A')
      : '-',
    newScheduleStart: req.newSchedule?.shiftStart
      ? moment(req.newSchedule.shiftStart).format('MMM Do, YYYY hh:mm A')
      : '-',
    newScheduleEnd: req.newSchedule?.shiftEnd
      ? moment(req.newSchedule.shiftEnd).format('MMM Do, YYYY hh:mm A')
      : '-',
    swapWith: req.swapWith || '-',
    reason: req.requestReason || '-',
  }));

  const ws = XLSX.utils.json_to_sheet(excelRows, {
    skipHeader: true,
    origin: 'A2',
  });

  XLSX.utils.sheet_add_aoa(ws, [subHeading], {
    skipHeader: true,
    origin: 'A1',
  });

  const range = XLSX.utils.decode_range(ws['!ref']);

  for (let C = 0; C < 26; C += 1) {
    const cellAddress = { c: C, r: 0 };
    const cellRef = XLSX.utils.encode_cell(cellAddress);
    if (!ws[cellRef]) ws[cellRef] = { t: 's', v: '' };
    ws[cellRef].s = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'dddddd' } },
    };
  }

  const totalColumns = range.e.c + 1;
  ws['!cols'] = Array(totalColumns).fill({ wpx: 150 });

  XLSX.utils.book_append_sheet(wb, ws, 'Change Requests');
  XLSX.writeFile(wb, 'schedule_change_requests.xlsx');
};

export default ScheduleChangeRequestsExcel;
